import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useShipFromValidation } from '../../ship-from/components/ship-from-dropdown/validator';
import Global from '../../store/global-selectors';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../../store/csw/csw.fulfillment-plan-to-csw';
import { useFulfillmentPlannerContext } from '../context';

const shipFromsSelectorFactory = () =>
  createSelector(
    (state) => Global.selectSellerShipFroms(state),
    (state) => Global.selectSellerActiveFulfillmentProviders(state),
    (_, showFulfillmentProviders) => showFulfillmentProviders,
    (shipFroms, sellerFulfillmentProviders, showFulfillmentProviders) => {
      const fulfillmentProviders = showFulfillmentProviders ? sellerFulfillmentProviders || [] : [];

      const fulfillmentProviderItems = fulfillmentProviders.map((provider) => ({
        name: provider.name,
        id: `${EXTERNAL_SHIP_FROM_PREFIX}${provider.sellerFulfillmentProviderId}`,
      }));

      const shipFromItems = shipFroms.map((shipFrom) => ({
        id: shipFrom.shipFromId,
        name: shipFrom.name,
        ...shipFrom,
      }));

      return fulfillmentProviderItems.concat(shipFromItems);
    },
  );

const ShipFromValidator = ({ children, fulfillmentPlanId, showFulfillmentProviders = false }) => {
  const { shipFromId } = useFulfillmentPlannerContext();
  const shipFromsSelector = useMemo(shipFromsSelectorFactory, []);
  const shipFroms = useSelector((state) => shipFromsSelector(state, showFulfillmentProviders));
  const selectedShipFromId = useSelector((state) => {
    // Show default shipFrom location if fulfillmentplan shipFromId no longer exists
    return shipFroms.find((shipFrom) => shipFrom.id === shipFromId) ? shipFromId : Global.selectSellerDefaultShipFromId(state);
  });

  const isExternalFulfillment = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanIsExternal(state, {
      fulfillmentPlanId,
    }),
  );

  const validation = useShipFromValidation({ selectedShipFromId, shipFroms });

  return children({
    validation: {
      ...(!isExternalFulfillment && validation),
    },
  });
};

export default memo(ShipFromValidator);
